import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './home/home.component';
import { CompareComponent } from './compare/compare.component';
import { CommitComponent } from './commit/commit.component';
import { BuildlistComponent } from './buildlist/buildlist.component';
import { BatchbranchComponent } from './batchbranch/batchbranch.component';
import { CommittrackerComponent } from './committracker/committracker.component';
import { CodeCoverageComponent } from './codecoverage/codecoverage.component';
import { DbComponent } from './db/db.component';
import { AppLinksComponent } from './applinks/applinks.component';
import { MsalGuard } from '@azure/msal-angular';
import { RoleGuardService } from './role-guard.service';
import { DebugToolsComponent } from './debugtools/debugtools.component';

import * as auth from './auth-config.json';

const routes: Routes = [
  { path: '', component: HomeComponent, pathMatch: 'full' },
  { path: 'compare', component: CompareComponent },
  { path: 'commit', component: CommitComponent },
  { path: 'applinks', component: AppLinksComponent },
  {
    path: 'buildlist',
    component: BuildlistComponent
  },
  { path: 'debugtools', component: DebugToolsComponent },
  {
    path: 'db',
    component: DbComponent,
    canActivate: [
      MsalGuard,
      RoleGuardService
    ],
    data: {
      expectedRole: [auth.roles.BuildManager]
    }
  },
  {
    path: 'batchbranch',
    component: BatchbranchComponent
  },
  {
    path: 'committracker',
    component: CommittrackerComponent
  },
  {
    path: 'codecoverage',
    component: CodeCoverageComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
